export enum folderTypes {
  NORMAL = 'normal',
  DELETED = 'deleted',
}
